import { defineStore } from 'pinia'

export const useConfigStore = defineStore('config', {
  state: () => ({
    title: '振兴伟业'
  }),
  actions: {
  }
})